// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { OrderExecutionType } from '@shared/utils/Trading/OrderExecutionType';
import { Resources } from '@shared/localizations/Resources';
export var ReportType;
(function (ReportType) {
    ReportType["REPORT_ORDERBOOK"] = "Order Book Report";
    ReportType["REPORT_TRADES"] = "Trades Report";
    ReportType["REPORT_STATEMENT"] = "Statement report";
    ReportType["REPORT_MAMACCOUNTSUMMARY"] = "MAM account summary";
    ReportType["REPORT_ORDER_HISTORY_LOAD_MORE"] = "Orders History";
    ReportType["REPORT_FILLED_ORDER_LOAD_MORE"] = "Filled Orders (trades)";
    ReportType["REPORT_STATEMENTS_LOAD_MORE"] = "Statements";
    ReportType["REPORT_MAM_SUMMARY_LOAD_MORE"] = "MAM Summary";
    ReportType["REPORT_SUBSCRIPTIONS_LOAD_MORE"] = "Subscriptions";
})(ReportType || (ReportType = {}));
export class AllowedReport {
    constructor(key, id, rawParams) {
        this.key = key;
        this.id = id;
        this.params = AllowedReport.parseRawParams(rawParams);
    }
    get keyForServer() {
        const key = this.key;
        if (!key)
            return '';
        return key.replace(key.includes(AllowedReport.REPORT_KEY_PREFIX)
            ? AllowedReport.REPORT_KEY_PREFIX
            : AllowedReport.TECHNICAL_REPORT_KEY_PREFIX, '');
    }
    toString() {
        const realKey = this.key.replace(AllowedReport.REPORT_KEY_PREFIX, '');
        const reportKey = 'reports.' + realKey;
        return Resources.getResource(Resources.IsResourcePresent(reportKey) ? reportKey : realKey);
    }
    static parseRawParams(rawParams) {
        const newParams = [];
        for (let i = 0, len = rawParams.length; i < len; i++) {
            const rawParam = rawParams[i];
            const allowedParam = new ReportParam(rawParam.name, rawParam.type);
            const rawOptionsStr = rawParam.params;
            if (rawOptionsStr) {
                const splits = rawOptionsStr.split(',');
                for (let j = 0, j_len = splits.length; j < j_len; j++) {
                    const split = splits[j];
                    if (!split)
                        continue;
                    const optionParts = split.split(':');
                    const val = optionParts[0];
                    const name = optionParts[1];
                    allowedParam.addValue(name, parseInt(val));
                }
            }
            newParams.push(allowedParam);
        }
        return newParams;
    }
    static EventFromString(strEventType) {
        let realEvent = strEventType;
        if (AllowedReport.OrderBookEventsLocalized[strEventType]) {
            realEvent = AllowedReport.OrderBookEventsLocalized[strEventType];
        }
        switch (realEvent) {
            case AllowedReport.SERVER_ORDER_BOOK_EVENT_NEW_10:
                return OrderExecutionType.NEW;
            case AllowedReport.SERVER_ORDER_BOOK_EVENT_REPLACE_20:
                return OrderExecutionType.REPLACED;
            case AllowedReport.SERVER_ORDER_BOOK_EVENT_RESTATE_42:
                return OrderExecutionType.RESTATED;
            case AllowedReport.SERVER_ORDER_BOOK_EVENT_ACTIVATED_43:
                return OrderExecutionType.ACTIVATED;
            case AllowedReport.SERVER_ORDER_BOOK_EVENT_ACCEPTED_11:
                return OrderExecutionType.ACCEPTED;
            case AllowedReport.SERVER_ORDER_BOOK_EVENT_PARTIALLY_FILLED_30:
                return OrderExecutionType.PART_FILLED;
            case AllowedReport.SERVER_ORDER_BOOK_EVENT_FILLED_31:
                return OrderExecutionType.FILLED;
            case AllowedReport.SERVER_ORDER_BOOK_EVENT_CANCELLED_40:
                return OrderExecutionType.CANCELED;
            case AllowedReport.SERVER_ORDER_BOOK_EVENT_REFUSED_41:
                return OrderExecutionType.REFUSED;
            default:
                return null;
        }
    }
    static Localize() {
        AllowedReport.OrderBookEventsLocalized = {};
        AllowedReport.OrderBookEventsLocalized[Resources.getResource('reports.' + AllowedReport.SERVER_ORDER_BOOK_EVENT_NEW_10)] = AllowedReport.SERVER_ORDER_BOOK_EVENT_NEW_10;
        AllowedReport.OrderBookEventsLocalized[Resources.getResource('reports.' + AllowedReport.SERVER_ORDER_BOOK_EVENT_REPLACE_20)] = AllowedReport.SERVER_ORDER_BOOK_EVENT_REPLACE_20;
        AllowedReport.OrderBookEventsLocalized[Resources.getResource('reports.' + AllowedReport.SERVER_ORDER_BOOK_EVENT_RESTATE_42)] = AllowedReport.SERVER_ORDER_BOOK_EVENT_RESTATE_42;
        AllowedReport.OrderBookEventsLocalized[Resources.getResource('reports.' + AllowedReport.SERVER_ORDER_BOOK_EVENT_ACTIVATED_43)] = AllowedReport.SERVER_ORDER_BOOK_EVENT_ACTIVATED_43;
        AllowedReport.OrderBookEventsLocalized[Resources.getResource('reports.' + AllowedReport.SERVER_ORDER_BOOK_EVENT_ACCEPTED_11)] = AllowedReport.SERVER_ORDER_BOOK_EVENT_ACCEPTED_11;
        AllowedReport.OrderBookEventsLocalized[Resources.getResource('reports.' + AllowedReport.SERVER_ORDER_BOOK_EVENT_PARTIALLY_FILLED_30)] = AllowedReport.SERVER_ORDER_BOOK_EVENT_PARTIALLY_FILLED_30;
        AllowedReport.OrderBookEventsLocalized[Resources.getResource('reports.' + AllowedReport.SERVER_ORDER_BOOK_EVENT_FILLED_31)] = AllowedReport.SERVER_ORDER_BOOK_EVENT_FILLED_31;
        AllowedReport.OrderBookEventsLocalized[Resources.getResource('reports.' + AllowedReport.SERVER_ORDER_BOOK_EVENT_CANCELLED_40)] = AllowedReport.SERVER_ORDER_BOOK_EVENT_CANCELLED_40;
        AllowedReport.OrderBookEventsLocalized[Resources.getResource('reports.' + AllowedReport.SERVER_ORDER_BOOK_EVENT_REFUSED_41)] = AllowedReport.SERVER_ORDER_BOOK_EVENT_REFUSED_41;
    }
}
AllowedReport.REPORT_KEY_PREFIX = '_REPORTKEY_';
AllowedReport.TECHNICAL_REPORT_KEY_PREFIX = '_TECHNICALREPORTKEY_';
AllowedReport.TOTAL_ROW_LABEL = 'Totals:';
AllowedReport.SERVER_ORDER_BOOK_EVENT_NEW_10 = 'Created';
AllowedReport.SERVER_ORDER_BOOK_EVENT_REPLACE_20 = 'Modified';
AllowedReport.SERVER_ORDER_BOOK_EVENT_RESTATE_42 = 'Restated';
AllowedReport.SERVER_ORDER_BOOK_EVENT_ACTIVATED_43 = 'Activated';
AllowedReport.SERVER_ORDER_BOOK_EVENT_ACCEPTED_11 = 'Accepted';
AllowedReport.SERVER_ORDER_BOOK_EVENT_PARTIALLY_FILLED_30 = 'Partially filled';
AllowedReport.SERVER_ORDER_BOOK_EVENT_FILLED_31 = 'Filled';
AllowedReport.SERVER_ORDER_BOOK_EVENT_CANCELLED_40 = 'Cancelled';
AllowedReport.SERVER_ORDER_BOOK_EVENT_REFUSED_41 = 'Rejected';
AllowedReport.OrderBookEventsLocalized = null;
export class ReportParam {
    constructor(name, type) {
        this.name = name;
        this.type = type;
        this.options = [];
    }
    addValue(text, value) {
        const locText = Resources.getResource('reports.' + text);
        this.options.push({ text: locText, value });
    }
    toString() {
        const key = 'reports.' + this.name;
        return Resources.IsResourcePresent(key) ? Resources.getResource(key) : this.name;
    }
}
Resources.AddStaticLocalization(AllowedReport.Localize);
